import { Typography } from "@mui/material";
import React from "react";
import styled, { keyframes } from "styled-components";

const Balota = ({ move, isModal = false, classHit }) => {
  return (
    <BalotaContent className={classHit}>
      <Typography className={isModal ? "modalp" : ""} component={"p"}>
        {move}
      </Typography>
    </BalotaContent>
  );
};

export default Balota;

const rotate = keyframes`
  0%{transform: rotate(0deg);}
  25%{transform: rotate(15deg);}
  50%{transform: rotate(0deg);}
  75%{transform: rotate(-15deg);}
  100%{transform: rotate(0deg);}
`;

const BalotaContent = styled.div`
  background: #fff;
  aspect-ratio: 1/1;
  border: 1px solid #262a34;
  border-radius: 50%;
  box-shadow: inset -5px -5px 10px rgba(38, 42, 52, 0.7);

  display: flex;
  justify-content: center;
  align-items: center;

  /* no clicks */
  pointer-events: none;

  p {
    /* ✅ ya NO depende del viewport */
    font-size: clamp(16px, 1.8em, 40px);
    font-weight: 700;
    font-family: "Roboto Mono", monospace;

    /* ✅ evita desbordes raros */
    line-height: 1;
    margin: 0;
    padding: 0;
    max-width: 90%;
    max-height: 90%;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;

    /* extra: render más estable en algunos navegadores */
    text-rendering: geometricPrecision;
  }

  /* Si quieres que en modal sea un poco más “controlado” */
  p.modalp {
    font-size: clamp(14px, 1.2em, 22px);
  }

  &.hit {
    background: radial-gradient(
      circle,
      rgba(255, 255, 255, 1) 30%,
      rgba(244, 208, 63, 1) 90%,
      rgba(244, 208, 63, 1) 100%
    );
    animation: ${rotate} 1.5s linear infinite;
  }

  /* Si en pantallas pequeñas necesitas un pelín más grande */
  @media (max-width: 1080px) {
    p {
      font-size: clamp(18px, 2.2em, 42px);
    }
    p.modalp {
      font-size: clamp(14px, 1.25em, 22px);
    }
  }
`;
